/* eslint-disable eqeqeq */
import { requestStatus } from "../../../../../constants";
import ExcelJS from "exceljs";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import * as FileSaver from "file-saver";
import { logoBase64 } from "../../../info-technology-process/repair-tools/base64";
import _ from "lodash";

export const isCreatedByCurrentUser = (detail: any, currentUser: string) => {
  return detail?.createdBy?.user?.email?.toLowerCase()?.split("@")?.[0] === currentUser.toLowerCase().split("@")?.[0];
};

export const isEnableEdit = (nextStep: number, detail: any, currentUser: string) => {
  return isCreatedByCurrentUser(detail, currentUser) && nextStep === 1;
};

export const isEnableEdit2 = (nextStep: number, detail: any, currentUser: string) => {
  //if(detail.fields.eRequestStatus == requestStatus.completed) return true

  return isCreatedByCurrentUser(detail, currentUser) && nextStep === 1;
};

export const getInforRegistrationCourse = (detail: any, currentUser: string, department: string) => {
  try {
    const eSubRequestsStatus = JSON.parse(detail.fields.eSubRequestsStatus)[department];

    return {
      status: eSubRequestsStatus.status,
      isApprover: eSubRequestsStatus.approver.toLowerCase().split("|")[0] === currentUser.toLocaleLowerCase(),
      approver: eSubRequestsStatus.approver,
    };
  } catch (error) {
    return {};
  }
};

export const addIndexToArray = (dataSource: any[]) => {
  return dataSource.map((value, index) => {
    return {
      ...value,
      index,
    };
  });
};

export const isHideApproveButton = (status: string) => {
  return [requestStatus.rejected, requestStatus.completed, requestStatus.submitted].includes(status);
};

export const isHideEdit = (status: string, isApprover?: boolean) => {
  if (status == requestStatus.submitted && isApprover) {
    return true;
  }

  return [requestStatus.rejected, requestStatus.completed].includes(status);
};

export function breakLine(ws: any, row: number) {
  for (const iterator of _.range(row)) {
    console.log(iterator);
    ws.addRow([]);
  }
}

export function makeBold(ws: any, rowIndex: number, colIndex: number) {
  ws.getCell(rowIndex, colIndex).value = {
    richText: [
      {
        font: {
          bold: true,
        },
        text: ws.getCell(rowIndex, colIndex).text,
      },
    ],
  };
}

export function exportExcel(record: any) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");

  const imageId = workbook.addImage({
    base64: logoBase64,
    extension: "png",
  });

  worksheet.addImage(imageId, "A1:D3");
  worksheet.addRow(["", "", "", "", "Biểu mẫu", `Mã số: ${record.fields.eIssueNumber}`]);
  worksheet.addRow([
    "",
    "",
    "",
    "",
    "BẢNG ĐĂNG KÝ NHÂN SỰ THAM GIA KHÓA HỌC",
    `Lần ban hành: ${record.fields.eIssueTimes}`,
  ]);

  worksheet.addRow(["", "", "", "", "", `Ngày hiệu lực:  ${getDDMMYYYFormat(record.fields.eIssueEffectiveDate)}`]);

  breakLine(worksheet, 1);

  worksheet.addRow([
    "Khóa học",
    "Loại hình đào tạo",
    "Họ và tên",
    "Mã nhân viên",
    "Đơn vị",
    "Ngày bắt đầu",
    "Ngày kết thúc",
  ]);

  for (const [item] of JSON.parse(record.fields.eContent).entries()) {
    worksheet.addRow([
      record.fields.eCourse,
      record.fields.eTrainingType,
      item.fullName,
      item.registerPersonel,
      item.unit,
      getDDMMYYYFormat(record.fields.eCourseDate),
      getDDMMYYYFormat(record.fields.eCourseDateEnd),
    ]);
  }

  breakLine(worksheet, 2);

  worksheet.addRow(["Người lập", "", "", "TCNL hoặc KHHC", "", "", "Tổng Giám đốc hoặc Giám đốc", "", ""]);

  let currentRowIdx = worksheet.rowCount;

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  breakLine(worksheet, 3);

  worksheet.addRow(["Họ và tên: ", "", "", "Họ và tên: ", "", "", "Họ và tên: ", "", ""]);

  currentRowIdx = worksheet.rowCount;

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);
  makeBold(worksheet, 1, 6);
  makeBold(worksheet, 2, 6);
  makeBold(worksheet, 3, 6);

  makeBold(worksheet, 1, 5);
  makeBold(worksheet, 2, 5);

  for (const i of _.range(7)) {
    makeBold(worksheet, 5, i + 1);
  }

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  worksheet.addRow(["Ngày: ", "", "", "Ngày: ", "", "", "Ngày: ", "", ""]);

  currentRowIdx = worksheet.rowCount;

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);

  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(blob, `Bảng đăng ký nhân sự tham gia khóa học - ${getDDMMYYYFormat(new Date())}`);
  });
}
